import posthog from 'posthog-js';

export const init = (config) => {
  if (!config?.api_key) return;

  const options = {
    api_host: config.api_host || 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageleave: true,
    capture_pageview: true,
  };

  posthog.init(config.api_key, options);
};

export const track = (eventName, params) => {
  posthog.capture(eventName, params);
};